module.exports = __webpack_public_path__ + "img/cot.5674f9bb.png";